// The Latlens mark and wordmark, shared with latlens.com and the maps app:
// a viewfinder (the lens) framing a point on the map.
export function BrandMark() {
  return (
    <span className="flex items-center gap-2.5 text-foreground" aria-label="Latlens">
      <svg viewBox="0 0 24 24" fill="none" className="h-6 w-6" aria-hidden="true">
        <path d="M4 9.5V4h5.5M20 14.5V20h-5.5" stroke="currentColor" strokeWidth="2" strokeLinecap="square" />
        <circle cx="12" cy="12" r="2.75" fill="rgb(var(--color-accent))" />
      </svg>
      <span className="text-[15px] font-semibold tracking-[0.08em]">LATLENS</span>
    </span>
  );
}
